import format from 'date-fns/format';

const dateFormat = 'd.MM.yyyy';

const formatDateRange = (from: string | Date, to: string | Date) => {
  const dateFrom = new Date(from);
  const dateTo = new Date(to);

  const [fromYear, toYear] = [dateFrom, dateTo].map((date) => date.getFullYear());

  if (fromYear !== toYear) {
    return `${format(dateFrom, dateFormat)}-${format(dateTo, dateFormat)}`;
  }

  const [fromMonth, toMonth] = [dateFrom, dateTo].map((date) => date.getMonth());

  if (fromMonth !== toMonth) {
    return `${format(dateFrom, 'd.MM')}-${format(dateTo, dateFormat)}`;
  }

  const [fromDay, toDay] = [dateFrom, dateTo].map((date) => date.getDay());

  if (fromDay !== toDay) {
    return `${format(dateFrom, 'd')}-${format(dateTo, dateFormat)}`;
  }

  return format(dateTo, dateFormat);
};

export default formatDateRange;
